import Joi from 'joi';
import type { IServiceClaims, IUserClaims } from './claims';
import type { ExtractValues } from '../helpers';

export const roles = [
  'admin',
  'hil',
  'console',
  'cluster',
  'premise',
  'project-service-account',
] as const;

export type Role = ExtractValues<typeof roles>;

export const roleSchema = Joi.string().valid(...roles);

const roleByClaim = {
  isConsole: 'console' as const,
  isAdmin: 'admin' as const,
  isHil: 'hil' as const,
  isPremise: 'premise' as const,
  isCluster: 'cluster' as const,
};

export function rolesFromToken(
  token?: Partial<IUserClaims & IServiceClaims & { [key: string]: unknown }>
): Role[] {
  if (!token || typeof token !== 'object') {
    return [];
  }

  const claimKeys = Object.keys(roleByClaim) as Array<keyof typeof roleByClaim>;

  return claimKeys
    .filter((key) => key in token && token[key] === true)
    .map((key) => roleByClaim[key]);
}
